

export const itemFilter = <T extends object>(item:T, searchFor: string | null, searchProps: (keyof T & string)[]):boolean => {
  if(!searchFor)
    return true

  const queryLow = searchFor.toLowerCase()

  return searchProps.some(prop => {
    const val = item[prop]
    console.log(prop, val)
    if(!val)
      return false

    return val.toString().toLowerCase().includes(queryLow)
  })
}
